"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EbmlTagId;
(function (EbmlTagId) {
    EbmlTagId[EbmlTagId["ChapterDisplay"] = 128] = "ChapterDisplay";
    EbmlTagId[EbmlTagId["TrackType"] = 131] = "TrackType";
    EbmlTagId[EbmlTagId["ChapString"] = 133] = "ChapString";
    EbmlTagId[EbmlTagId["CodecID"] = 134] = "CodecID";
    EbmlTagId[EbmlTagId["FlagDefault"] = 136] = "FlagDefault";
    EbmlTagId[EbmlTagId["ChapterTrackNumber"] = 137] = "ChapterTrackNumber";
    EbmlTagId[EbmlTagId["ChapterTimeStart"] = 145] = "ChapterTimeStart";
    EbmlTagId[EbmlTagId["ChapterTimeEnd"] = 146] = "ChapterTimeEnd";
    EbmlTagId[EbmlTagId["CueRefTime"] = 150] = "CueRefTime";
    EbmlTagId[EbmlTagId["CueRefCluster"] = 151] = "CueRefCluster";
    EbmlTagId[EbmlTagId["ChapterFlagHidden"] = 152] = "ChapterFlagHidden";
    EbmlTagId[EbmlTagId["ContentCompAlgo"] = 16980] = "ContentCompAlgo";
    EbmlTagId[EbmlTagId["ContentCompSettings"] = 16981] = "ContentCompSettings";
    EbmlTagId[EbmlTagId["DocType"] = 17026] = "DocType";
    EbmlTagId[EbmlTagId["DocTypeReadVersion"] = 17029] = "DocTypeReadVersion";
    EbmlTagId[EbmlTagId["EBMLVersion"] = 17030] = "EBMLVersion";
    EbmlTagId[EbmlTagId["DocTypeVersion"] = 17031] = "DocTypeVersion";
    EbmlTagId[EbmlTagId["SegmentFamily"] = 17476] = "SegmentFamily";
    EbmlTagId[EbmlTagId["DateUTC"] = 17505] = "DateUTC";
    EbmlTagId[EbmlTagId["TagDefault"] = 17540] = "TagDefault";
    EbmlTagId[EbmlTagId["TagBinary"] = 17541] = "TagBinary";
    EbmlTagId[EbmlTagId["TagString"] = 17543] = "TagString";
    EbmlTagId[EbmlTagId["Duration"] = 17545] = "Duration";
    EbmlTagId[EbmlTagId["ChapterFlagEnabled"] = 17816] = "ChapterFlagEnabled";
    EbmlTagId[EbmlTagId["FileMimeType"] = 18016] = "FileMimeType";
    EbmlTagId[EbmlTagId["FileUsedStartTime"] = 18017] = "FileUsedStartTime";
    EbmlTagId[EbmlTagId["FileUsedEndTime"] = 18018] = "FileUsedEndTime";
    EbmlTagId[EbmlTagId["FileReferral"] = 18037] = "FileReferral";
    EbmlTagId[EbmlTagId["ContentEncodingOrder"] = 20529] = "ContentEncodingOrder";
    EbmlTagId[EbmlTagId["ContentEncodingScope"] = 20530] = "ContentEncodingScope";
    EbmlTagId[EbmlTagId["ContentEncodingType"] = 20531] = "ContentEncodingType";
    EbmlTagId[EbmlTagId["ContentCompression"] = 20532] = "ContentCompression";
    EbmlTagId[EbmlTagId["ContentEncryption"] = 20533] = "ContentEncryption";
    EbmlTagId[EbmlTagId["CueBlockNumber"] = 21368] = "CueBlockNumber";
    EbmlTagId[EbmlTagId["ChapterStringUID"] = 22100] = "ChapterStringUID";
    EbmlTagId[EbmlTagId["WritingApp"] = 22337] = "WritingApp";
    EbmlTagId[EbmlTagId["SilentTracks"] = 22612] = "SilentTracks";
    EbmlTagId[EbmlTagId["ContentEncoding"] = 25152] = "ContentEncoding";
    EbmlTagId[EbmlTagId["BitDepth"] = 25188] = "BitDepth";
    EbmlTagId[EbmlTagId["SignedElement"] = 25906] = "SignedElement";
    EbmlTagId[EbmlTagId["TrackTranslate"] = 26148] = "TrackTranslate";
    EbmlTagId[EbmlTagId["ChapProcessCommand"] = 26897] = "ChapProcessCommand";
    EbmlTagId[EbmlTagId["ChapProcessTime"] = 26914] = "ChapProcessTime";
    EbmlTagId[EbmlTagId["ChapterTranslate"] = 26916] = "ChapterTranslate";
    EbmlTagId[EbmlTagId["ChapProcessData"] = 26931] = "ChapProcessData";
    EbmlTagId[EbmlTagId["ChapProcess"] = 26948] = "ChapProcess";
    EbmlTagId[EbmlTagId["ChapProcessCodecID"] = 26965] = "ChapProcessCodecID";
    EbmlTagId[EbmlTagId["Tag"] = 29555] = "Tag";
    EbmlTagId[EbmlTagId["SegmentFilename"] = 29572] = "SegmentFilename";
    EbmlTagId[EbmlTagId["AttachmentLink"] = 29766] = "AttachmentLink";
    EbmlTagId[EbmlTagId["CodecName"] = 2459272] = "CodecName";
    EbmlTagId[EbmlTagId["Segment"] = 408125543] = "Segment";
    EbmlTagId[EbmlTagId["TagLanguage"] = 17530] = "TagLanguage";
    EbmlTagId[EbmlTagId["TagName"] = 17827] = "TagName";
    EbmlTagId[EbmlTagId["SimpleTag"] = 26568] = "SimpleTag";
    EbmlTagId[EbmlTagId["TagAttachmentUID"] = 25542] = "TagAttachmentUID";
    EbmlTagId[EbmlTagId["TagChapterUID"] = 25540] = "TagChapterUID";
    EbmlTagId[EbmlTagId["TagEditionUID"] = 25545] = "TagEditionUID";
    EbmlTagId[EbmlTagId["TagTrackUID"] = 25541] = "TagTrackUID";
    EbmlTagId[EbmlTagId["TargetType"] = 25546] = "TargetType";
    EbmlTagId[EbmlTagId["TargetTypeValue"] = 26826] = "TargetTypeValue";
    EbmlTagId[EbmlTagId["Targets"] = 25536] = "Targets";
    EbmlTagId[EbmlTagId["Tags"] = 307544935] = "Tags";
    EbmlTagId[EbmlTagId["ChapProcessPrivate"] = 17677] = "ChapProcessPrivate";
    EbmlTagId[EbmlTagId["ChapCountry"] = 17278] = "ChapCountry";
    EbmlTagId[EbmlTagId["ChapLanguage"] = 17276] = "ChapLanguage";
    EbmlTagId[EbmlTagId["ChapterTrack"] = 143] = "ChapterTrack";
    EbmlTagId[EbmlTagId["ChapterPhysicalEquiv"] = 25539] = "ChapterPhysicalEquiv";
    EbmlTagId[EbmlTagId["ChapterSegmentEditionUID"] = 28348] = "ChapterSegmentEditionUID";
    EbmlTagId[EbmlTagId["ChapterSegmentUID"] = 28263] = "ChapterSegmentUID";
    EbmlTagId[EbmlTagId["ChapterUID"] = 29636] = "ChapterUID";
    EbmlTagId[EbmlTagId["ChapterAtom"] = 182] = "ChapterAtom";
    EbmlTagId[EbmlTagId["EditionFlagOrdered"] = 17885] = "EditionFlagOrdered";
    EbmlTagId[EbmlTagId["EditionFlagDefault"] = 17883] = "EditionFlagDefault";
    EbmlTagId[EbmlTagId["EditionFlagHidden"] = 17853] = "EditionFlagHidden";
    EbmlTagId[EbmlTagId["EditionUID"] = 17852] = "EditionUID";
    EbmlTagId[EbmlTagId["EditionEntry"] = 17849] = "EditionEntry";
    EbmlTagId[EbmlTagId["Chapters"] = 272869232] = "Chapters";
    EbmlTagId[EbmlTagId["FileUID"] = 18094] = "FileUID";
    EbmlTagId[EbmlTagId["FileData"] = 18012] = "FileData";
    EbmlTagId[EbmlTagId["FileName"] = 18030] = "FileName";
    EbmlTagId[EbmlTagId["FileDescription"] = 18046] = "FileDescription";
    EbmlTagId[EbmlTagId["AttachedFile"] = 24999] = "AttachedFile";
    EbmlTagId[EbmlTagId["Attachments"] = 423732329] = "Attachments";
    EbmlTagId[EbmlTagId["CueRefCodecState"] = 235] = "CueRefCodecState";
    EbmlTagId[EbmlTagId["CueRefNumber"] = 21343] = "CueRefNumber";
    EbmlTagId[EbmlTagId["CueReference"] = 219] = "CueReference";
    EbmlTagId[EbmlTagId["CueCodecState"] = 234] = "CueCodecState";
    EbmlTagId[EbmlTagId["CueDuration"] = 178] = "CueDuration";
    EbmlTagId[EbmlTagId["CueRelativePosition"] = 240] = "CueRelativePosition";
    EbmlTagId[EbmlTagId["CueClusterPosition"] = 241] = "CueClusterPosition";
    EbmlTagId[EbmlTagId["CueTrack"] = 247] = "CueTrack";
    EbmlTagId[EbmlTagId["CueTrackPositions"] = 183] = "CueTrackPositions";
    EbmlTagId[EbmlTagId["CueTime"] = 179] = "CueTime";
    EbmlTagId[EbmlTagId["CuePoint"] = 187] = "CuePoint";
    EbmlTagId[EbmlTagId["Cues"] = 475249515] = "Cues";
    EbmlTagId[EbmlTagId["AESSettingsCipherMode"] = 18408] = "AESSettingsCipherMode";
    EbmlTagId[EbmlTagId["ContentEncAESSettings"] = 18407] = "ContentEncAESSettings";
    EbmlTagId[EbmlTagId["ContentSigHashAlgo"] = 18406] = "ContentSigHashAlgo";
    EbmlTagId[EbmlTagId["ContentSigAlgo"] = 18405] = "ContentSigAlgo";
    EbmlTagId[EbmlTagId["ContentSigKeyID"] = 18404] = "ContentSigKeyID";
    EbmlTagId[EbmlTagId["ContentSignature"] = 18403] = "ContentSignature";
    EbmlTagId[EbmlTagId["ContentEncKeyID"] = 18402] = "ContentEncKeyID";
    EbmlTagId[EbmlTagId["ContentEncAlgo"] = 18401] = "ContentEncAlgo";
    EbmlTagId[EbmlTagId["ContentEncodings"] = 28032] = "ContentEncodings";
    EbmlTagId[EbmlTagId["TrickMasterTrackSegmentUID"] = 196] = "TrickMasterTrackSegmentUID";
    EbmlTagId[EbmlTagId["TrickMasterTrackUID"] = 199] = "TrickMasterTrackUID";
    EbmlTagId[EbmlTagId["TrickTrackFlag"] = 198] = "TrickTrackFlag";
    EbmlTagId[EbmlTagId["TrickTrackSegmentUID"] = 193] = "TrickTrackSegmentUID";
    EbmlTagId[EbmlTagId["TrickTrackUID"] = 192] = "TrickTrackUID";
    EbmlTagId[EbmlTagId["TrackJoinUID"] = 237] = "TrackJoinUID";
    EbmlTagId[EbmlTagId["TrackJoinBlocks"] = 233] = "TrackJoinBlocks";
    EbmlTagId[EbmlTagId["TrackPlaneType"] = 230] = "TrackPlaneType";
    EbmlTagId[EbmlTagId["TrackPlaneUID"] = 229] = "TrackPlaneUID";
    EbmlTagId[EbmlTagId["TrackPlane"] = 228] = "TrackPlane";
    EbmlTagId[EbmlTagId["TrackCombinePlanes"] = 227] = "TrackCombinePlanes";
    EbmlTagId[EbmlTagId["TrackOperation"] = 226] = "TrackOperation";
    EbmlTagId[EbmlTagId["ChannelPositions"] = 32123] = "ChannelPositions";
    EbmlTagId[EbmlTagId["Channels"] = 159] = "Channels";
    EbmlTagId[EbmlTagId["OutputSamplingFrequency"] = 30901] = "OutputSamplingFrequency";
    EbmlTagId[EbmlTagId["SamplingFrequency"] = 181] = "SamplingFrequency";
    EbmlTagId[EbmlTagId["Audio"] = 225] = "Audio";
    EbmlTagId[EbmlTagId["FrameRate"] = 2327523] = "FrameRate";
    EbmlTagId[EbmlTagId["GammaValue"] = 3126563] = "GammaValue";
    EbmlTagId[EbmlTagId["ColourSpace"] = 3061028] = "ColourSpace";
    EbmlTagId[EbmlTagId["AspectRatioType"] = 21683] = "AspectRatioType";
    EbmlTagId[EbmlTagId["DisplayUnit"] = 21682] = "DisplayUnit";
    EbmlTagId[EbmlTagId["DisplayHeight"] = 21690] = "DisplayHeight";
    EbmlTagId[EbmlTagId["DisplayWidth"] = 21680] = "DisplayWidth";
    EbmlTagId[EbmlTagId["PixelCropRight"] = 21725] = "PixelCropRight";
    EbmlTagId[EbmlTagId["PixelCropLeft"] = 21708] = "PixelCropLeft";
    EbmlTagId[EbmlTagId["PixelCropTop"] = 21691] = "PixelCropTop";
    EbmlTagId[EbmlTagId["PixelCropBottom"] = 21674] = "PixelCropBottom";
    EbmlTagId[EbmlTagId["PixelHeight"] = 186] = "PixelHeight";
    EbmlTagId[EbmlTagId["PixelWidth"] = 176] = "PixelWidth";
    EbmlTagId[EbmlTagId["OldStereoMode"] = 21433] = "OldStereoMode";
    EbmlTagId[EbmlTagId["AlphaMode"] = 21440] = "AlphaMode";
    EbmlTagId[EbmlTagId["StereoMode"] = 21432] = "StereoMode";
    EbmlTagId[EbmlTagId["FlagInterlaced"] = 154] = "FlagInterlaced";
    EbmlTagId[EbmlTagId["Video"] = 224] = "Video";
    EbmlTagId[EbmlTagId["TrackTranslateTrackID"] = 26277] = "TrackTranslateTrackID";
    EbmlTagId[EbmlTagId["TrackTranslateCodec"] = 26303] = "TrackTranslateCodec";
    EbmlTagId[EbmlTagId["TrackTranslateEditionUID"] = 26364] = "TrackTranslateEditionUID";
    EbmlTagId[EbmlTagId["SeekPreRoll"] = 22203] = "SeekPreRoll";
    EbmlTagId[EbmlTagId["CodecDelay"] = 22186] = "CodecDelay";
    EbmlTagId[EbmlTagId["TrackOverlay"] = 28587] = "TrackOverlay";
    EbmlTagId[EbmlTagId["CodecDecodeAll"] = 170] = "CodecDecodeAll";
    EbmlTagId[EbmlTagId["CodecDownloadURL"] = 2536000] = "CodecDownloadURL";
    EbmlTagId[EbmlTagId["CodecInfoURL"] = 3883072] = "CodecInfoURL";
    EbmlTagId[EbmlTagId["CodecSettings"] = 3839639] = "CodecSettings";
    EbmlTagId[EbmlTagId["CodecPrivate"] = 25506] = "CodecPrivate";
    EbmlTagId[EbmlTagId["Language"] = 2274716] = "Language";
    EbmlTagId[EbmlTagId["Name"] = 21358] = "Name";
    EbmlTagId[EbmlTagId["MaxBlockAdditionID"] = 21998] = "MaxBlockAdditionID";
    EbmlTagId[EbmlTagId["TrackOffset"] = 21375] = "TrackOffset";
    EbmlTagId[EbmlTagId["TrackTimecodeScale"] = 2306383] = "TrackTimecodeScale";
    EbmlTagId[EbmlTagId["DefaultDecodedFieldDuration"] = 2313850] = "DefaultDecodedFieldDuration";
    EbmlTagId[EbmlTagId["DefaultDuration"] = 2352003] = "DefaultDuration";
    EbmlTagId[EbmlTagId["MaxCache"] = 28152] = "MaxCache";
    EbmlTagId[EbmlTagId["MinCache"] = 28135] = "MinCache";
    EbmlTagId[EbmlTagId["FlagLacing"] = 156] = "FlagLacing";
    EbmlTagId[EbmlTagId["FlagForced"] = 21930] = "FlagForced";
    EbmlTagId[EbmlTagId["FlagEnabled"] = 185] = "FlagEnabled";
    EbmlTagId[EbmlTagId["TrackUID"] = 29637] = "TrackUID";
    EbmlTagId[EbmlTagId["TrackNumber"] = 215] = "TrackNumber";
    EbmlTagId[EbmlTagId["TrackEntry"] = 174] = "TrackEntry";
    EbmlTagId[EbmlTagId["Tracks"] = 374648427] = "Tracks";
    EbmlTagId[EbmlTagId["EncryptedBlock"] = 175] = "EncryptedBlock";
    EbmlTagId[EbmlTagId["ReferenceTimeCode"] = 202] = "ReferenceTimeCode";
    EbmlTagId[EbmlTagId["ReferenceOffset"] = 201] = "ReferenceOffset";
    EbmlTagId[EbmlTagId["ReferenceFrame"] = 200] = "ReferenceFrame";
    EbmlTagId[EbmlTagId["SliceDuration"] = 207] = "SliceDuration";
    EbmlTagId[EbmlTagId["Delay"] = 206] = "Delay";
    EbmlTagId[EbmlTagId["BlockAdditionID"] = 203] = "BlockAdditionID";
    EbmlTagId[EbmlTagId["FrameNumber"] = 205] = "FrameNumber";
    EbmlTagId[EbmlTagId["LaceNumber"] = 204] = "LaceNumber";
    EbmlTagId[EbmlTagId["TimeSlice"] = 232] = "TimeSlice";
    EbmlTagId[EbmlTagId["Slices"] = 142] = "Slices";
    EbmlTagId[EbmlTagId["DiscardPadding"] = 30114] = "DiscardPadding";
    EbmlTagId[EbmlTagId["CodecState"] = 164] = "CodecState";
    EbmlTagId[EbmlTagId["ReferenceVirtual"] = 253] = "ReferenceVirtual";
    EbmlTagId[EbmlTagId["ReferenceBlock"] = 251] = "ReferenceBlock";
    EbmlTagId[EbmlTagId["ReferencePriority"] = 250] = "ReferencePriority";
    EbmlTagId[EbmlTagId["BlockDuration"] = 155] = "BlockDuration";
    EbmlTagId[EbmlTagId["BlockAdditional"] = 165] = "BlockAdditional";
    EbmlTagId[EbmlTagId["BlockAddID"] = 238] = "BlockAddID";
    EbmlTagId[EbmlTagId["BlockMore"] = 166] = "BlockMore";
    EbmlTagId[EbmlTagId["BlockAdditions"] = 30113] = "BlockAdditions";
    EbmlTagId[EbmlTagId["BlockVirtual"] = 162] = "BlockVirtual";
    EbmlTagId[EbmlTagId["Block"] = 161] = "Block";
    EbmlTagId[EbmlTagId["BlockGroup"] = 160] = "BlockGroup";
    EbmlTagId[EbmlTagId["SimpleBlock"] = 163] = "SimpleBlock";
    EbmlTagId[EbmlTagId["PrevSize"] = 171] = "PrevSize";
    EbmlTagId[EbmlTagId["Position"] = 167] = "Position";
    EbmlTagId[EbmlTagId["SilentTrackNumber"] = 22743] = "SilentTrackNumber";
    EbmlTagId[EbmlTagId["Timecode"] = 231] = "Timecode";
    EbmlTagId[EbmlTagId["Cluster"] = 524531317] = "Cluster";
    EbmlTagId[EbmlTagId["MuxingApp"] = 19840] = "MuxingApp";
    EbmlTagId[EbmlTagId["Title"] = 31657] = "Title";
    EbmlTagId[EbmlTagId["TimecodeScaleDenominator"] = 2807730] = "TimecodeScaleDenominator";
    EbmlTagId[EbmlTagId["TimecodeScale"] = 2807729] = "TimecodeScale";
    EbmlTagId[EbmlTagId["ChapterTranslateID"] = 27045] = "ChapterTranslateID";
    EbmlTagId[EbmlTagId["ChapterTranslateCodec"] = 27071] = "ChapterTranslateCodec";
    EbmlTagId[EbmlTagId["ChapterTranslateEditionUID"] = 27132] = "ChapterTranslateEditionUID";
    EbmlTagId[EbmlTagId["NextFilename"] = 4096955] = "NextFilename";
    EbmlTagId[EbmlTagId["NextUID"] = 4110627] = "NextUID";
    EbmlTagId[EbmlTagId["PrevFilename"] = 3965867] = "PrevFilename";
    EbmlTagId[EbmlTagId["PrevUID"] = 3979555] = "PrevUID";
    EbmlTagId[EbmlTagId["SegmentUID"] = 29604] = "SegmentUID";
    EbmlTagId[EbmlTagId["Info"] = 357149030] = "Info";
    EbmlTagId[EbmlTagId["SeekPosition"] = 21420] = "SeekPosition";
    EbmlTagId[EbmlTagId["SeekID"] = 21419] = "SeekID";
    EbmlTagId[EbmlTagId["Seek"] = 19899] = "Seek";
    EbmlTagId[EbmlTagId["SeekHead"] = 290298740] = "SeekHead";
    EbmlTagId[EbmlTagId["SignatureElementList"] = 32379] = "SignatureElementList";
    EbmlTagId[EbmlTagId["SignatureElements"] = 32347] = "SignatureElements";
    EbmlTagId[EbmlTagId["Signature"] = 32437] = "Signature";
    EbmlTagId[EbmlTagId["SignaturePublicKey"] = 32421] = "SignaturePublicKey";
    EbmlTagId[EbmlTagId["SignatureHash"] = 32410] = "SignatureHash";
    EbmlTagId[EbmlTagId["SignatureAlgo"] = 32394] = "SignatureAlgo";
    EbmlTagId[EbmlTagId["SignatureSlot"] = 458458727] = "SignatureSlot";
    EbmlTagId[EbmlTagId["CRC32"] = 191] = "CRC32";
    EbmlTagId[EbmlTagId["Void"] = 236] = "Void";
    EbmlTagId[EbmlTagId["EBMLMaxSizeLength"] = 17139] = "EBMLMaxSizeLength";
    EbmlTagId[EbmlTagId["EBMLMaxIDLength"] = 17138] = "EBMLMaxIDLength";
    EbmlTagId[EbmlTagId["EBMLReadVersion"] = 17143] = "EBMLReadVersion";
    EbmlTagId[EbmlTagId["EBML"] = 440786851] = "EBML";
})(EbmlTagId = exports.EbmlTagId || (exports.EbmlTagId = {}));
